/**
 * Allows throwing error without reporting it to log tools such as Sentry.
 */
export class IgnoredError extends Error {}
